module.exports = __webpack_public_path__ + "static/products_sec2-8109f9fbdf5422dcc3450ac124af01d7.svg";